module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_1.8e937e0c.png";